import { Popup as MapPopup } from "@l2r-front/l2r-map"
import { styled } from "@l2r-front/l2r-ui"

export const Popup = styled(MapPopup)(({ theme }) => ({
    "& .mapboxgl-popup-tip": {
        display: "none",
    },
    "& .mapboxgl-popup-content": {
        borderRadius: theme.spacing(3),
        boxShadow: theme.customShadow("LCS/Shadow-simple"),
        padding: theme.spacing(2),
    },
}))